import { Provider, CodeResult, AccountStorageBalance } from '../types';

const loadAccountStorageBalance = async ({
  provider,
  tokenId,
  tokenOwnerId,
}: {
  provider: Provider;
  tokenId: string;
  tokenOwnerId: string;
}): Promise<{
  tokenId: string;
  existing: boolean;
  storageBalance: AccountStorageBalance | null;
}> => {
  if (!tokenId || !tokenOwnerId) {
    console.error(
      'No token id or token owner id for loading account storage balance',
      `tokenId: ${tokenId}`,
      `tokenOwnerId: ${tokenOwnerId}`
    );

    return { tokenId, existing: false, storageBalance: null };
  }

  const res = (await provider
    .query<CodeResult>({
      request_type: 'call_function',
      account_id: tokenId,
      method_name: 'storage_balance_of',
      args_base64: Buffer.from(
        JSON.stringify({ account_id: tokenOwnerId })
      ).toString('base64'),
      finality: 'optimistic',
    })
    .then((res) =>
      JSON.parse(Buffer.from(res.result).toString())
    )) as AccountStorageBalance | null;

  return { tokenId, existing: res !== null, storageBalance: res };
};

export { loadAccountStorageBalance };
